import { render } from "./DialogWindow.vue?vue&type=template&id=6a32c77a"
import script from "./DialogWindow.vue?vue&type=script&lang=js"
export * from "./DialogWindow.vue?vue&type=script&lang=js"

import exportComponent from "D:\\projects\\mitool\\MITOOL\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__